import { ReactNode, useCallback, useLayoutEffect, useState } from "react";
import { Modal } from "semantic-ui-react";
import CommonModalCloseIcon from "../../../../assets/commonIcon/CommonModalCloseIcon";
import "../../../../components/commonModal/commonModal.scss";

interface LegacySemanticModalProps {
  modalOpenState: boolean;
  modalCloseState: (state: boolean) => void;
  children: ReactNode;
  title?: string;
  size?: "mini" | "tiny" | "small" | "large" | "fullscreen";
  centered?: boolean;
  customModalTitleMain?: string;
  customModalTitle?: string;
  customDimmer?: string;
  style?: React.CSSProperties;
  testId?: string;
}

const LegacySemanticModal = ({
  modalOpenState,
  modalCloseState,
  children,
  title,
  size = "small",
  centered = false,
  customModalTitleMain,
  customModalTitle,
  customDimmer,
  style,
  testId
}: LegacySemanticModalProps) => {
  const getInitialSize = () => {
    if (window.innerWidth < 991) return "small";
    if (window.innerWidth < 1700) return "middle";
    return "large";
  };

  const [sizeStatus, setSizeStatus] = useState(getInitialSize);

  useLayoutEffect(() => {
    const handleResize = () => {
      setSizeStatus(getInitialSize());
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getMainContentView = useCallback(() => {
    switch (sizeStatus) {
      case "large":
        return "customDimmerLayoutLarge";
      case "middle":
        return "customDimmerLayoutMiddle";
      case "small":
        return "customDimmerLayoutSmall";
      default:
        return "customDimmerLayoutLarge";
    }
  }, [sizeStatus]);

  return (
    <Modal
      centered={centered}
      size={size}
      onClose={() => {
        modalCloseState(false);
      }}
      open={modalOpenState}
      className={`${customDimmer ?? ""} ${getMainContentView()}`}
      style={style}
      data-testid={testId}
    >
      <Modal.Content className="full-height">
        <Modal.Description className="modal-description">
          {title ? (
            <div className={`commonModalMain ${customModalTitleMain ?? ""}`}>
              <h3 className={`commonModalTitle ${customModalTitle ?? ""}`}>{title}</h3>
              <CommonModalCloseIcon
                className="commonModalCloseIcon"
                onClick={() => modalCloseState(false)}
              />
            </div>
          ) : null}
          {children}
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

export default LegacySemanticModal;
